const LinkOn = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9.5a2.5 2.5 0 0 0 0 5h3.5a.5.5 0 0 1 0 1H7a3.5 3.5 0 1 1 0-7h3.5a.5.5 0 0 1 0 1zm6-.5a.5.5 0 0 1 .5-.5H17a3.5 3.5 0 1 1 0 7h-3.5a.5.5 0 0 1 0-1H17a2.5 2.5 0 0 0 0-5h-3.5A.5.5 0 0 1 13 9m-3.5 3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5"
      clipRule="evenodd"
    />
  </>
)
export default LinkOn
